var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container bg-gray-neutral-100 relative overflow-hidden" },
    [
      _c(
        "div",
        { staticClass: "flex flex-wrap -mx-grap items-center flex-col mb-4" },
        [
          _c("div", { staticClass: "w-12/12 md:w-4/12 text-center" }, [
            _c("h2", { staticClass: "text-blue-dark font-bold mt-4 mb-0" }, [
              _vm._v(_vm._s(_vm.content.title)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "w-12/12 md:w-5/12 text-center" }, [
            _c("p", { staticClass: "text-blue-dark mt-1 mb-1" }, [
              _vm._v(_vm._s(_vm.content.sub)),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass:
                  "text-blue-default text-xl font-bold no-underline border-b-2 border-blue-default mt-1/2 hover:no-underline cursor-pointer",
                on: {
                  click: function ($event) {
                    _vm.open = !_vm.open
                  },
                },
              },
              [_vm._v(_vm._s(_vm.content.link.text))]
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex flex-wrap px-1 md:px-5 justify-between mb-4" },
        _vm._l(_vm.content.features, function (feature, index) {
          return _c("div", { key: index, staticClass: "w-12/12 md:w-auto" }, [
            _c("p", { staticClass: "font-semibold text-blue-dark text-22" }, [
              _vm._v("\n        " + _vm._s(feature.title) + "\n      "),
            ]),
            _vm._v(" "),
            _c(
              "ul",
              { staticClass: "list-disc list-inside min-w-[250px]" },
              _vm._l(feature.list, function (item, i) {
                return _c(
                  "li",
                  {
                    key: i,
                    staticClass: "text-22 font-normal text-blue-dark leading-8",
                  },
                  [_vm._v("\n          " + _vm._s(item) + "\n        ")]
                )
              }),
              0
            ),
          ])
        }),
        0
      ),
      _vm._v(" "),
      _c("circles"),
      _vm._v(" "),
      _c("circles", { staticClass: "second" }),
      _vm._v(" "),
      _vm.open
        ? _c("LicensePopup", {
            attrs: { content: _vm.content },
            on: {
              close: function ($event) {
                _vm.open = !_vm.open
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }